<template>
  <div class="item mb5">
    <input v-model="item.label" class="input">
    <button type="button" class="btnDel" @click="delCategory"></button>
  </div>
</template>

<script>
export default {
  name: 'CategoryItem',
  props: [
    'item',
    'locale'
  ],
  methods: {
    delCategory () {
      if (window.confirm(this.locale.confirm_delete)) {
        this.$emit('delCategory', this.item.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.item {
  position: relative;
}
.input {
  opacity: 0.5;
  cursor: pointer;
  &:focus {
    opacity: 1;
    cursor: initial;
  }
}
.btnDel {
  position: absolute;
  top: 50%;
  right: 0;
  width: 50px;
  height: 100%;
  transform: translate(0, -50%);
  &:before,
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 1px;
    margin-left: -10px;
    background-color: $color-dark;
    transform-origin: 50% 50%;
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
}
</style>
